import { SWReactIcons } from "@similarweb/icons";
import styled from "styled-components";

export const StyledGAIcon = styled(SWReactIcons)`
    position: absolute;
    top: 30%;
    left: 3%;
    cursor: pointer;
`;
